import moment from "moment";

export function isLoggedIn() {
  let session = getObject("neptuneAdmin") || {};
  session = Object.keys(session).length && JSON.parse(session);
  let accessToken = session;
  return accessToken;
}
export function getObject(key) {
  if (window && window.localStorage) {
    return window.localStorage.getItem(key);
  }
}
export const isAuthor = (id) => {
  // console.log(id, "id");
  // const userData = JSON.parse(localStorage.getItem("comm"));
  const adminId = localStorage.getItem("communityId");

  if (adminId) {
    if (adminId !== id) {
      return true;
    } else {
      return false;
    }
  }
};
export const base64ToFile = (url, name) => {
  let arr = url.split(",");
  // console.log(arr)
  let mime = arr[0].match(/:(.*?);/)[1];
  let data = arr[1];

  let dataStr = atob(data);
  let n = dataStr.length;
  let dataArr = new Uint8Array(n);

  while (n--) {
    dataArr[n] = dataStr.charCodeAt(n);
  }

  let file = new File([dataArr], name, { type: mime });

  return file;
};
export function groupBy(array, key) {
  let getTimestamp = (str) => +new Date(...str.split("-").reverse());
  const arr = array.reduce((acc, obj) => {
    const property = moment(obj[key]).format("DD-MM-YYYY");
    acc[property] = acc[property] || [];
    acc[property].push(obj);
    return acc;
  }, {});
  let completeArr = [];
  for (let a in arr) {
    completeArr.push({ date: a, data: arr[a] });
  }
  return completeArr.sort(
    (a, b) => getTimestamp(a.date) - getTimestamp(b.date)
  );
}

// this function is used for display time like (today ,yesterday,and other date)
export const todaysDate = (date) => {
  if (date === moment().format("DD-MM-YYYY")) {
    return "Today";
  } else if (date === moment().add(-1, "days").format("DD-MM-YYYY")) {
    return "Yesterday";
  } else {
    return date;
  }
};
